export const createFormRef = () => ({
  errors: {},
  handleSubmit: null,
  isDirty: false,
});
